module.exports = __webpack_public_path__ + "img/bana_yes.b4906dcd.png";